import { MultiStepWizard } from '../MultiStepWizard/MultiStepWizard'
import { MultiStepLinkedInPlanningSchema } from '../schemas/LinkedInPlanning'
import { MultiStepLinkedInPlanningWizardProps } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ASPECT_RATIOS, DesignChannel } from 'components/NewFileModal/Types'
import { ChooseTopic } from '../PlanningWizard/ChooseTopic/ChooseTopic'
import { SelectCaptions } from '../PlanningWizard/SelectCaptions/SelectCaptions'
import { PlanContent } from '../PlanningWizard/PlanContent/PlanContent'
import { ContentPlanningProvider, useContentPlanningContext } from '../PlanningWizard/ContentPlanningContext'
import { useState } from 'react'
import { MediaType } from '../schemas/shared/mediaType'

const MultiStepLinkedInPlanningWizard = (
  props: MultiStepLinkedInPlanningWizardProps & {
    mediaType: MediaType
    setMediaType: (mediaType: MediaType) => void
  },
) => {
  const { generateCampaign } = useContentPlanningContext()
  const { width, height } = ASPECT_RATIOS['linkedin-post']
  const { mediaType, setMediaType } = props

  return (
    <MultiStepWizard.Root
      {...props}
      schema={MultiStepLinkedInPlanningSchema}
      onSubmit={generateCampaign}
      initialValues={{
        ...props.initialValues,
        media_type: mediaType,
        width,
        height,
        source_visual_element_ids: props.initialValues?.source_visual_element_ids || [],
      }}
    >
      <ChooseTopic
        header="Enter a Topic for Your LinkedIn Posts"
        subHeader="Blaze will help you write and schedule a cluster of content around this topic linked to a Blaze campaign for easy reference."
        onChange={(values) => setMediaType(values.media_type)}
      />
      <SelectCaptions
        header="Select LinkedIn Posts"
        subHeader="Select posts related to your topic. You can edit them directly on this page."
        inputPlaceholder="Write your own post..."
        nextLabel={() => 'Plan'}
      />
      <PlanContent
        header="Plan Your LinkedIn Calendar"
        subHeader="Select a date and time for each of your posts or have Blaze pick for you."
        externalIntegrationType={ExternalIntegrationEnum.LinkedIn}
        previousLabel={mediaType === 'design' ? 'Templates' : 'Posts'}
      />
    </MultiStepWizard.Root>
  )
}

const MultiStepLinkedInPlanningWizardContainer = (props: MultiStepLinkedInPlanningWizardProps) => {
  const [mediaType, setMediaType] = useState(props.initialValues?.media_type || MediaType.DocumentWithImages)

  return (
    <ContentPlanningProvider
      captionsGenerationType={ChannelType.LinkedInPosts}
      generationType={mediaType === MediaType.Design ? DesignChannel.LinkedInPost : ChannelType.LinkedInPosts}
      initialValues={props.initialValues}
    >
      <MultiStepLinkedInPlanningWizard mediaType={mediaType} setMediaType={setMediaType} {...props} />
    </ContentPlanningProvider>
  )
}

export { MultiStepLinkedInPlanningWizardContainer as MultiStepLinkedInPlanningWizard }
